export const DESKTOP_MIN_WIDTH = 768;
export const MOBILE_MAX_WIDTH = DESKTOP_MIN_WIDTH + 1;

export const NOT_FOUND_MSG =
  'We didn’t find any results.Try a different title or description.';
export const NOT_FOUND_MSG_DYNAMIC =
  'We didn’t find any results for Search term. Try a different title or description.';

export const TEST_SEARCH_ALPHANUMERIC = 'Test 1';
export const TEST_SEARCH_STRING = 'Search Term';
export const TEST_UNIT_MSG = 'No results found for';
